import axios, { AxiosRequestConfig } from 'axios'
import {
  api_cargoflux_shipments_path,
  export_api_cargoflux_shipments_path,
} from '../routes'

export function getCargoFluxShipmentsByJobnumberId(jobnumberId) {
  const options: AxiosRequestConfig = {
    url: api_cargoflux_shipments_path({ format: 'json', jobnumber_id: jobnumberId }),
    method: 'get',
    responseType: 'json',
  }
  return axios(options).then(response => response.data)
}

export function getCargoFluxShipmentsExportUrl(jobnumberId) {
  return export_api_cargoflux_shipments_path({ format: 'xlsx', jobnumber_id: jobnumberId })
}
